import React, { useId } from "react";
import { IconButton, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { focusRing } from "./regmStyles";

// Small info button with a tooltip. Always a sibling of other controls, never inside a button or label.
// Opens on hover, keyboard focus and tap (no touch delay). The text is also exposed through
// aria-describedby on a hidden element, so it is reachable even while the tooltip is closed.
// spaced widens the gap for adjacent icons so their hit areas overlap less.
// The icon is 16px; an enlarged invisible hit area brings the touch target to 40px.
const HelpTip = ({ text, label, placement = "top", spaced = false }) => {
  const descId = useId();
  return (
    <>
      <Tooltip title={text} placement={placement} arrow enterTouchDelay={0} leaveTouchDelay={6000}>
        <IconButton
          size="small"
          aria-label={`About ${label}`}
          aria-describedby={descId}
          sx={{
            p: 0.25,
            ml: spaced ? 1 : 0.5,
            color: "text.secondary",
            verticalAlign: "middle",
            position: "relative",
            "&::after": { content: '""', position: "absolute", inset: -10 },
            ...focusRing,
          }}
        >
          <InfoOutlinedIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
      <span id={descId} hidden>
        {text}
      </span>
    </>
  );
};

export default HelpTip;
